import React, { Fragment, useRef, useEffect, useCallback, useState } from 'react';
import { debounce } from 'lodash';
import { getDestinations } from '../service';
import popularCitiesHolidays from '../popularCitiesHolidays';

import './DestSearch.css';

export const HEADER = 'HEADER';

const DestSearchV1 = ({ cityArr = [], onChange }) => (
  <>
    {cityArr.map((dest, idx) => (
      <div
        key={idx}
        className="linear-dest-city"
        onClick={() =>
          onChange({ destCity: dest?.name, parentCity: dest?.name, destValue: dest?.name })
        }
      >
        {dest?.name}
      </div>
    ))}
  </>
);

const RecentSearchV2 = ({ showRecentSearch, recentSearch, onChange }) => {
  if (!showRecentSearch || recentSearch.length === 0) {
    return null;
  }
  return (
    <>
      <div className="dest-citypicker-title">RECENTLY SEARCHED</div>
      {recentSearch.map((destData = {}, idx) => {
        const { childType, destValue, parentType } = destData;
        destData.type = 'Recently_Viewed';
        return (
          <Fragment key={idx}>
            <div>
              <div
                className="dest-city-container"
                onClick={() => onChange({ ...destData, sectionName: 'recent search' })}
              >
                <div>
                  <div className="dest-city-name">{destValue}</div>
                </div>
                <div className="dest-city-type">{childType || parentType}</div>
              </div>
            </div>
          </Fragment>
        );
      })}
    </>
  );
};

const DestOptionV2 = ({ citiesList, onChange }) =>
  citiesList.map((cityData = {}, idx) => {
    const {
      displayName: parentCity = '',
      packages = 0,
      subList: subCities = [],
      destinationType = '',
      data: parentData = {},
      type,
    } = cityData;

    const destData = {
      destValue: parentData?.displayNameOnSelect || parentCity,
      parentCity,
      parentType: destinationType,
      type: 'Popular',
      ...cityData,
    };

    if (parentData?.filters) destData.filters = parentData.filters;
    if (parentData?.destinationCity) destData.destCity = parentData.destinationCity;
    if (parentData?.campaign) destData.campaign = parentData.campaign;

    return (
      <Fragment key={idx}>
        <div>
          {type !== HEADER ? (
            <div
              className="dest-city-container"
              onClick={() => onChange({ ...destData, sectionName: 'search' })}
            >
              <div>
                <div className="dest-city-name">{parentCity}</div>
                {packages !== 0 && (
                  <div className="dest-city-packages">{`${packages} Packages`}</div>
                )}
              </div>
              <div className="dest-city-type">{destinationType}</div>
            </div>
          ) : (
            <div className="dest-citypicker-title">{parentCity}</div>
          )}
          {type !== HEADER &&
            subCities &&
            subCities.map((subCityData = {}, subIdx) => {
              const {
                entityType = '',
                displayName: subCity = '',
                packageCount = 0,
                data: subData = {},
              } = subCityData;
              return (
                <div
                  className="dest-city-container"
                  key={`sub_${subIdx}`}
                  onClick={() =>
                    onChange({
                      ...destData,
                      destCity: subData.destinationCity || '',
                      childCity: subCity,
                      childType: entityType,
                      filters: subData.filters,
                      destValue: subData.displayNameOnSelect || subCity,
                      sectionName: 'search',
                    })
                  }
                >
                  <div className="makeFlex">
                    <div className="dest-left-indicator" />
                    <div className="dest-city-name">{subCity}</div>
                    <div className="dest-city-packages">{`(${packageCount} Packages)`}</div>
                  </div>
                  <div className="dest-city-type">{entityType}</div>
                </div>
              );
            })}
        </div>
      </Fragment>
    );
  });

const DestSearch = ({ label, onChange, showDestV2, recentSearch = [], departureCity = '' }) => {
  const [citiesList, setCitiesList] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [showRecentSearch, setShowRecentSearch] = useState(true);
  const [loading, setLoading] = useState(true);
  const inputEl = useRef(null);

  const destCityData = async () => {
    const response = await getDestinations(
      { context: 'SEARCH', searchTerm: '', branch: 'DOM', departureCity },
      showDestV2
    );
    return response;
  };

  useEffect(() => {
    (async () => {
      inputEl.current.focus();
      if (showDestV2) {
        const response = await destCityData();
        setCitiesList(response?.data?.searchDestinationList || []);
      }
      setLoading(false);
    })();
  }, []);

  const searchDestinations = async val => {
    const response = await getDestinations(
      { context: 'SEARCH', searchTerm: val, branch: 'DOM', departureCity },
      showDestV2
    );
    setCitiesList(response?.data?.searchDestinationList || []);
  };

  const debouncedSearch = useCallback(debounce(searchDestinations, 200), []);

  const onInputChange = e => {
    const val = e.target.value;
    debouncedSearch(val);
    setSearchText(val);
    setShowRecentSearch(val === '');
  };

  return (
    <>
      <div className="dest-search-container">
        <input
          ref={inputEl}
          placeholder={label}
          className="dest-search-input"
          type="text"
          onChange={onInputChange}
        />
        <div className="dest-search-list">
          {!loading ? (
            citiesList?.length > 0 ? (
              showDestV2 ? (
                <>
                  <RecentSearchV2 {...{ showRecentSearch, recentSearch, onChange }} />
                  <DestOptionV2 {...{ citiesList, onChange }} />
                </>
              ) : (
                <DestSearchV1 cityArr={citiesList} onChange={onChange} />
              )
            ) : searchText.length ? (
              <div className="no-data-found">No Data Found</div>
            ) : (
              <>
                <div className="dest-citypicker-title">POPULAR CITIES</div>
                <DestSearchV1
                  cityArr={popularCitiesHolidays()}
                  onChange={destData => onChange({ ...destData, sectionName: 'popular' })}
                />
              </>
            )
          ) : (
            <div className="chatLoaderWrap">
              <p className="chatLoaderOuter">
                <span className="chatLoaderInner" />
              </p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default DestSearch;
